import {Component, Input} from '@angular/core';

import { Denuncia } from '../denuncia/denuncia';
import { DenunciaService } from '../denuncia/denuncia.service';

import { Incidente } from '../incidente/incidente';
import { IncidenteService } from '../incidente/incidente.service';
import { Encaminhamento } from '../incidente/encaminhamento';


import { Router, ActivatedRoute, Params } from '@angular/router';


@Component({
  selector: 'app-modal-encam',
  template: `
  <div id="modale" (click)="onContainerClicked($event)" class="modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
       [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal();">&times;</button>
        <h4 class="modal-title">Encaminhamento do incidente</h4>
          <!--<ng-content select=".app-modal-header"></ng-content>-->
        </div>
        <form id="login-form">
        <div class="modal-body">
            <label for="selectDescricao">Descrição da análise do caso:</label>
            <textarea class="form-control" rows="4" id="inputDescricao" name="descricaoencam" [(ngModel)]="desc" placeholder="Descreva a análise do caso"></textarea>
            <p></p>
          <label for="selectEncaminhamento">Tipos de encaminhamento (marque todos que considerar pertinente)</label>
            <p *ngIf="flagPsic" style="color: red;">Encaminhamento psicológico já realizado!</p>
            <div class="checkbox" *ngFor="let encaminhamento of encaminhamentos; let in = index">
              <label>
              <input type="checkbox" checked="{{ this.listaItens && -1 !== this.listaItens.indexOf(encaminhamento.nome) ? 'checked' : '' }}"  (change)="selEncaminhamento(encaminhamento.id,$event)">{{encaminhamento.nome}}
              <span class="legenda" *ngIf="encaminhamento.id == 1">Para realizar um encaminhamento psicologico, na tela "Listar entrevistas" selecione o ícone de símbolo sino relativo à pessoa que deseja encaminhar.</span>
              </label>
              <textarea *ngIf="encaminhamento.id != 1" class="form-control" rows="3" cols="8" id="descricaoEnc" name="txtEncam{{in}}" [(ngModel)]="textoEncaminhamentos[encaminhamento.id]" placeholder="Descreva melhor o encaminhamento escolhido acima"></textarea>
            </div>
          <ng-content select=".app-modal-body"></ng-content>
        </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="closeModal();">Fechar</button>
            <button class="btn btn-success" (click)="salvarEncaminhamento();" data-dismiss="modalr">Salvar</button>
          </div>
        <!--<div class="modal-footer">
            <div class="col-sm-offset-2 col-sm-10">
            <button type="button" class="btn btn-default" (click)="closeModal();">Fechar</button>
            <button class="btn btn-success" (click)="salvarEncaminhamento();" data-dismiss="modalr">Salvar</button>
            </div>
          <ng-content select=".app-modal-footer"></ng-content>
        </div>-->
        </form>
      </div>
    </div>
  </div>
  `,
  styles: [`
    .modal {
      background: rgba(0,0,0,0.6);
    }
  `],
  providers: [
    DenunciaService,
    IncidenteService
  ]
})
export class ModalEncaminhamentoComponent {

  public visible = false;
  private visibleAnimate = false;

  denuncia: Denuncia;

  incidente: Incidente;

  encaminhamentos: Encaminhamento[];

  itensEncaminhamento = [];

  descricaoencam: string;

  listaItens: string;

  flagPsic: boolean;

  @Input() desc:string;
  @Input() idInc: number;
  @Input() textoEncaminhamentos: any[] = [];

  constructor(private denService: DenunciaService, private incidenteService: IncidenteService, private router: Router){
  }

  selEncaminhamento(value,event) {
    //alert(value);

    if (value == 1) {
      this.router.navigate(['/listar-entrevistas/' + this.idInc]);
    }
    else {
      if (event.target.checked) {
        this.itensEncaminhamento.push(value);
      }
      else if (!event.target.checked) {
        let indexx = this.itensEncaminhamento.indexOf(value);
        this.itensEncaminhamento.splice(indexx,1);
      }
      //console.log("CHECKBOX ENCAMINHAMENTOS ");
      //console.log(this.itensEncaminhamento);
    }
  }


  public show(id): void {

    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);

    this.idInc = id;

    this.incidenteService.getDadosIncidente(id)
    .then((resposta) => {this.flagPsic = resposta.encamPsic;
    this.desc = resposta.descEncam;

    for (var ch in resposta.txtEncam) {
      this.textoEncaminhamentos[ch] = resposta.txtEncam[ch];
    }

    this.itensEncaminhamento = resposta.listaencaminhamentos;
    this.listaItens = resposta.listaencam;
    this.incidente = resposta;
    //console.log(this.flagPsic);
    });

    this.incidenteService.getEncaminhamento(id)
    .then((encaminhamento) => {this.encaminhamentos = encaminhamento});

  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public closeModal(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);

  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  public salvarEncaminhamento(): void {
    this.incidente = new Incidente;

    // definindo o id do incidente e os dados do encaminhamento
    this.incidente.id = this.idInc;
    this.incidente.descricaoencam = this.desc; // descricao da analise do caso
    this.incidente.itensEncamFinal = this.itensEncaminhamento; // array com os ids dos encaminhamentos escolhidos
    this.incidente.encaminhado = true;
    this.incidente.flagPsicologico = false;


    //console.log(this.textoEncaminhamentos);

    let dados: { [chave: number]: string } = {};
    for (var ch in this.textoEncaminhamentos) {
      //console.log(ch);
      //console.log(this.textoEncaminhamentos[ch]);
      dados[ch] = this.textoEncaminhamentos[ch];
    }

    this.incidente.txtEncaminhamentos = dados; // array com os ids e os textos dos encaminhamentos escolhidos

    //console.log(dados);

    //console.log(this.incidente);


    this.incidenteService.salvarEncaminhamento(this.incidente)
        .then((resposta) => this.goBack(resposta))

    // fecha a janela modal
    this.hide();

  }

  goBack(resposta: any): void {
     alert(resposta);
     window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/denuncias/modalencaminhamento.component.ts